import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { customTheme } from "../../../../../config/theme/MuiTheme";
import { setSnackbar } from "../../../../../util/state/globalAction";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import { equipmentActions } from "../service/equipment.actions";
import EquipmentTypes from "../Types";

export type EquipmentKitDeleteTypes = "kit" | "equipment";

interface Props {
  tenant:string;
  isOpen: boolean;
  onClose: () => void;
  equipment?: EquipmentTypes.IEquipment;
  onUpdateDatasource?: () => void;
}

const DeleteConfirmation = (props: Props) => {
  const { dispatchGlobalData } = useContext(GlobalContext);

  const { t } = useTranslation(["operation"]);
  const equipment = equipmentActions();

  const onDeleteEquipment = () => {
    if (props.equipment) {
      equipment
        .deleteEquipment(props.tenant,props.equipment.id || 0)
        .then((response: any) => {
          props.onClose();

          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t(
                  "vehicleEquipment.kitTab.deleteConfirmation.removedEquipment"
                ),
                type: snackbarTypes.success,
                show: true,
                autoClose: true,
              },
            },
          });

          props.onUpdateDatasource && props.onUpdateDatasource();
        })
        .catch((error: any) => {
          props.onClose();
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message:
                  error.status === 409
                    ? t(
                        "vehicleEquipment.kitTab.deleteConfirmation.errorCanNotRemove",
                        {
                          equipmentCode: textMessage,
                        }
                      )
                    : t(
                        "vehicleEquipment.kitTab.deleteConfirmation.errorRemove"
                      ),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
        });
    }
  };

  const textMessage = useMemo(() => {
    return `"${props.equipment?.code} - ${props.equipment?.descr}"`;
  }, [props.equipment]);
  return (
    <Mui.Dialog open={props.isOpen} onClose={props.onClose}>
      <Mui.DialogTitle>
        <Mui.Grid container columnSpacing={1}>
          <Mui.Grid item xs="auto" color={customTheme.palette.accent.main}>
            <MuiIcons.Info color="inherit" />
          </Mui.Grid>

          <Mui.Grid item xs="auto">
            <Mui.Typography variant="h5">
              {t("vehicleEquipment.kitTab.deleteConfirmation.title")}
            </Mui.Typography>
          </Mui.Grid>

          <Mui.Grid item xs="auto" marginLeft="auto">
            <Mui.IconButton onClick={props.onClose}>
              <MuiIcons.Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>

      <Mui.DialogContent>
        <Mui.Typography
          variant="bodySmall"
          color="#18305B"
          style={{ whiteSpace: "pre-line" }}
        >
          {t("vehicleEquipment.kitTab.deleteConfirmation.description").replace(
            "#textElement",
            textMessage || ""
          )}
        </Mui.Typography>
      </Mui.DialogContent>

      <Mui.DialogActions>
        <Mui.Button variant="outlined" onClick={props.onClose}>
          {t("vehicleEquipment.kitTab.deleteConfirmation.actions.cancel")}
        </Mui.Button>

        <Mui.Button variant="contained" onClick={onDeleteEquipment}>
          {t(
            "vehicleEquipment.kitTab.deleteConfirmation.actions.deleteEquipment"
          )}
        </Mui.Button>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};

export default DeleteConfirmation;
